import * as React from 'react';
import NotificationOverview from '../components/NotificationOverview';
import NotificationDetail from '../components/NotificationDetail';
import { Route, Switch } from 'react-router-dom';

class ConsumerNotifications extends React.Component<any> {
  public get basePath() {
    return `/subscriptions/:assetId/:environment/notifications`;
  }

  public render() {
    return (
        <Switch>
          <Route path={`${this.basePath}`} exact component={NotificationOverview} />
          <Route path={`${this.basePath}/add`} exact component={NotificationDetail} />
          <Route path={`${this.basePath}/:notificationId`} component={NotificationDetail} />
        </Switch>
      );
    };
}

export default ConsumerNotifications;



// WEBPACK FOOTER //
// ./src/modules/consumer/pages/ConsumerNotifications.tsx